import { createRoot } from "react-dom/client";
import App from "./App.tsx";
import "./index.css";

// Auto-recover from stale chunk/CSS preload errors after a new deploy
// Only suppress the error when we actually reload; otherwise preventDefault makes
// the dynamic import resolve to undefined and React.lazy crashes on `.default`.
window.addEventListener("vite:preloadError", (event) => {
  const key = "__vite_preload_reload__";
  if (sessionStorage.getItem(key)) return;
  event.preventDefault();
  sessionStorage.setItem(key, "1");
  window.location.reload();
});
window.addEventListener("load", () => {
  sessionStorage.removeItem("__vite_preload_reload__");
});

createRoot(document.getElementById("root")!).render(<App />);
